import React, { useState, useMemo, useRef } from 'react';
import FullWidthModal from '../../components/common/Modal/FullWidthModal';
import ModalHeader from '../../components/common/ModalHeader/index';
import Modal from '../../components/common/Modal/index';
import cn from 'classnames';
import styles from './viewreceipt.module.scss';
import { TouchableButton } from '../../components/common/Touchable/index';
import { LABEL } from '../../veriables';
import Loader from '../../components/common/Loader/newLoaderModal';
import { connect } from 'react-redux';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';

const RewardRedemptionModal = props => {
  const {
    isOpen,
    serverAppTheme,
    seat,
    reward,
    onRedeem,
    onBack,
    loading,
    orderingPortraitOrientation,
    setErrorPopUp,
  } = props;

  const defaultValue = reward?.value != null ? reward.value.toFixed(2) : '';
  const [enteredValue, setEnteredValue] = useState(defaultValue);
  const [isManualEntry, setIsManualEntry] = useState(false);
  const inputRef = useRef(null);

  // Handle keyboard button clicks (same pattern as Tips/index.jsx)
  const onBtnClick = (key) => {
    setEnteredValue(prev => {
      if (key === '{bksp}') {
        return prev.slice(0, -1);
      }
      if (key === '.') {
        // only one decimal point allowed
        if (prev.includes('.')) return prev;
        return prev + key;
      }
      // Prevent more than 2 decimal places
      // const dotIdx = prev.indexOf('.');
      // if (dotIdx !== -1 && prev.length - dotIdx > 2) return prev;
      return prev + key;
    });
  };

  const handleRedeem = () => {
    // Use enteredValue if present and valid, else fall back to reward.value
    // const valueToUse = enteredValue !== '' ? enteredValue : defaultValue;
    const parsed = parseFloat(enteredValue);
    if (isNaN(parsed) || parsed <= 0 || parsed > reward?.value) {
      const maxDisplay = reward?.value != null
        ? `${LABEL().CURRENCY_SYMBOL}${reward.value.toFixed(2)}`
        : '';
      setErrorPopUp({
        res: `Please enter a value less than or equal to ${maxDisplay}.`,
        noErrorTxt: true,
      });
      return;
    }
    onRedeem(parsed);
  };

  const handleInputChange = e => {
    const raw = e.target.value;
    if (/^\d*\.?\d{0,2}$/.test(raw)) {
      setEnteredValue(raw);
      setIsManualEntry(true);
    }
  };

  const handleInputFocus = () => {
    // Blur the native input to prevent native keyboard on tablets
    if (inputRef.current) inputRef.current.blur();
  };

  return (
    <>
      <FullWidthModal
        isOpen={isOpen}
        customClass2={cn('w-100 h-100 position-relative')}
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          pointerEvents: 'auto',
          backgroundColor: serverAppTheme?.popUp_bg,
          backgroundClip: 'padding-box',
          border: '0',
          boxShadow: serverAppTheme?.popUp_box_shadow,
        }}
      >
        {loading && <Loader />}
        <div
          className="col-12 px-0 justify-content-center align-items-center position-relative text-center h-100"
        >
          <div
            className={cn(
              'col-12 px-0 fs_18 align-items-center justify-content-center fw-600 h-100'
            )}
          >
            <ModalHeader
              stationName={seat?.stationName}
              tileHeader={LABEL().LS_REWARD_REDEMPTION}
              seatNumber={seat?.number}
            />
            <div className={cn('col-12 px-0', orderingPortraitOrientation ? 'h-83' : '')}>
            <div
              className={cn(
                'd-flex flex-column align-items-center justify-content-center',
                orderingPortraitOrientation ? `${styles.padding150} px-3` : ''
              )}
            >
              <div
                className={cn(
                  'd-flex flex-column align-items-center',
                  orderingPortraitOrientation ? "col-12 px-0" : "col-8"
                )}
                style={{ fontFamily: 'Poppins' }}
              >
                {/* Rewards Value display — updates as user types */}
                <div
                  className="col-12 pt-2 px-0 d-flex justify-content-center align-items-center rounded fs-24 fw-500"
                  style={{ color: serverAppTheme?.primary_text }}
                >
                   {LABEL().LS_REWARDS_VALUE} : {LABEL().CURRENCY_SYMBOL}
                  {(reward.value ?? 0).toFixed(2)}
                </div>
                <div
                  className="col-12 px-0 d-flex justify-content-center align-items-center rounded fs-24 fw-400 pt-3"
                  style={{ color: serverAppTheme?.primary_text }}
                >
                  {LABEL().LS_AMOUNT_TO_REDEEM}
                </div>

                {/* Input field — bordered box, $ left, value right-aligned */}
                <div
                  className="col-12 px-0 d-flex align-items-center mt-1 w-100"
                  style={{
                    // border: `1.5px solid ${serverAppTheme?.primary_text || '#ccc'}`,
                    // borderRadius: '6px',
                    background: serverAppTheme?.inputBg || 'transparent',
                    height: '7vh',
                    minHeight: '52px',
                  }}
                >
                  {/* $ prefix pinned to the left */}
                  <span
                    className="fs_24 fw-600 pl-3"
                    style={{ color: serverAppTheme?.primary_text, whiteSpace: 'nowrap' }}
                  >
                    {LABEL().CURRENCY_SYMBOL}
                  </span>

                  {/* Numeric value, right-aligned */}
                  <input
                    ref={inputRef}
                    className="w-100 h-100 fs_24 fw-500 pr-3"
                    style={{
                      textAlign: 'right',
                      background: 'transparent',
                      border: 'none',
                      outline: 'none',
                      boxShadow: 'none',
                      color: serverAppTheme?.primary_text,
                    }}
                    name="rewardAmount"
                    id="rewardAmount"
                    value={enteredValue}
                    onChange={handleInputChange}
                    onFocus={handleInputFocus}
                    placeholder="0.00"
                    readOnly
                  />
                </div>

                {/* Custom numeric keyboard */}
                <div className={cn('col-12 text-center pt-2 px-0')}>
                  <CustomKeyboard
                    onClickBtn={(e) => {
                      if (!isManualEntry) {
                        setEnteredValue('');
                        setIsManualEntry(true);
                      }
                      onBtnClick(e);
                    }}
                    type="numericDot"
                    isClr
                    typed={enteredValue}
                    maxLength={100}
                    isDot
                    customClass={'fs-30 pb-1 pl-1'}
                    serverAppTheme={serverAppTheme}
                  />
                </div>
              </div>
            </div>
            </div>

            <div
              className={cn(
                'h-20 color-white d-flex justify-content-center',
                orderingPortraitOrientation ? `col-12 px-3 pt-30` : 'pt-24'
              )}
            >
              <div
                className={cn(
                  'pl-0 pr-0 d-flex mb-1 mr-2',
                  orderingPortraitOrientation ? 'col-6' : 'col-4'
                )}
              >
                <TouchableButton
                  type="button"
                  className={cn(
                    'col-12 px-0 d-flex justify-content-center align-items-center od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color',
                    styles.loyalty_btn
                  )}
                  onClick={event => {
                    event.preventDefault();
                    onBack();
                  }}
                  style={{
                    height: '7.5vh',
                    backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                    color: serverAppTheme?.primary_text,
                    border: '1px solid #2541A4',
                  }}
                  rippleEffect={true}
                >
                  <div className={cn('fw-600', orderingPortraitOrientation ? 'fs_28' : 'fs_24')}>
                    {LABEL().PF_CANCEL}
                  </div>
                </TouchableButton>
              </div>
              <div
                className={cn(
                  'pl-0 pr-0 d-flex mb-1 justify-content-start',
                  orderingPortraitOrientation ? 'col-6' : 'col-4'
                )}
              >
                <TouchableButton
                  type="button"
                  className={cn(
                    'col-12 px-0 btn-ripple d-flex justify-content-center align-items-center od-primary-btn-bg-color od-primary-btn-font-color',
                    styles.loyalty_btn
                  )}
                  style={{ height: '7.5vh' }}
                  onClick={event => {
                    event.preventDefault();
                    handleRedeem();
                  }}
                  rippleEffect={true}
                >
                  <div className={cn('fw-600', orderingPortraitOrientation ? 'fs_28' : 'fs_24')}>
                    {LABEL().LS_REDEEM}
                  </div>
                </TouchableButton>
              </div>
            </div>
          </div>
        </div>
      </FullWidthModal>
    </>
  );
};

const mapStateToProps = ({ orders }) => ({
  orderingPortraitOrientation: orders.orderingPortraitOrientation,
});

export default connect(mapStateToProps)(RewardRedemptionModal);
